import { makeRequest, makeUpload } from "./makeRequest";

//======================================================================================================================
//
//                                                  URL
//
//======================================================================================================================

export const API_URL = window.API_URL;
export const API_URL_UP = window.API_URL_BASE;
export const API_URL_BASE = window.API_URL_BASE;

import { _3mc_On } from "../Modules/DM/NonComponents/DMConst";
import { GB_VersionName } from "../Modules/GB/NonComponents/GBConst";

//======================================================================================================================
//
//                                             SERVER CALLS
//
//======================================================================================================================

export const LoginService = {
    ping: (mySuccess, myError) => makeRequest(API_URL, CLIENT_ID, "GBLoginServiceV2.Ping", {}, {}, mySuccess, myError),

    sum: (a, b, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "GBLoginServiceV2.Sum",
            {
                A: a,
                B: b,
            },
            {},
            mySuccess,
            myError
        ),

    signedIn: (mySuccess, myError) =>
        makeRequest(API_URL, CLIENT_ID, "GBLoginServiceV2.SignedIn", {}, {}, mySuccess, myError),

    login: (userName, password, mode, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "GBLoginServiceV2.Login",
            {},
            {
                userName: userName,
                password: password,
                mode: mode,
            },
            mySuccess,
            myError
        ),

    loginAsGuest: (mode, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "GBLoginServiceV2.Login",
            {},
            {
                userName: "guest",
                password: "12345",
                mode: mode,
            },
            mySuccess,
            myError
        ),

    logout: (mySuccess, myError) =>
        makeRequest(API_URL, CLIENT_ID, "GBLoginServiceV2.LogOut", {}, {}, mySuccess, myError),

    getHumanName: (mySuccess, myError) =>
        makeRequest(API_URL, CLIENT_ID, "GBLoginServiceV2.GetHumanName", {}, {}, mySuccess, myError),

    getUsername: (mySuccess, myError) =>
        makeRequest(API_URL, CLIENT_ID, "GBLoginServiceV2.GetUsername", {}, {}, mySuccess, myError),

    getClientID: (mySuccess, myError) =>
        makeRequest(API_URL, CLIENT_ID, "GBLoginServiceV2.GetClientID", {}, {}, mySuccess, myError),
};

export const SCService = {
    ping: (mySuccess, myError) => makeRequest(API_URL, CLIENT_ID, "SCServiceV2.Ping", {}, {}, mySuccess, myError),

    sum: (a, b, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "SCServiceV2.Sum",
            {},
            {
                A: a,
                B: b,
            },
            mySuccess,
            myError
        ),

    createProject: (countryCode, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "SCServiceV2.CreateProject",
            {},
            {
                dataFileName: "DataFileName",
                countryCode: countryCode,
                startYear: 2010,
                endYear: new Date().getFullYear(),
            },
            mySuccess,
            myError
        ),

    getUsername: (mySuccess, myError) =>
        makeRequest(API_URL, CLIENT_ID, "SCServiceV2.GetUsername", {}, {}, mySuccess, myError),

    getClientID: (mySuccess, myError) =>
        makeRequest(API_URL, CLIENT_ID, "SCServiceV2.GetClientID", {}, {}, mySuccess, myError),

    getConfigOptObj: (mySuccess, myError) =>
        makeRequest(API_URL, CLIENT_ID, "SCServiceV2.GetConfigOptObj", {}, {}, mySuccess, myError),

    setConfigOptObj: (configOpt, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "SCServiceV2.SetConfigOptObj",
            {},
            {
                configOpt: configOpt,
            },
            mySuccess,
            myError
        ),

    getResultChart: (resultID, configOpt, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "SCServiceV2.GetResultChart",
            {},
            {
                resultID: resultID,
                configOpt: configOpt,
            },
            mySuccess,
            myError
        ),

    getResultTable: (resultID, configOpt, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "SCServiceV2.GetResultTable",
            {},
            {
                resultID: resultID,
                configOpt: configOpt,
            },
            mySuccess,
            myError
        ),

    getDisplayOL: (mySuccess, myError) =>
        makeRequest(API_URL, CLIENT_ID, "SCServiceV2.GetDisplayOL", {}, {}, mySuccess, myError),

    sendEmail: (fileName, data, countryName, provinceName, SNU_Name, siteName, dateSubmitted, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "SCServiceV2.SendEmail",
            {},
            {
                fileName: fileName,
                data: data,
                countryName: countryName,
                provinceName: provinceName,
                SNU_Name: SNU_Name,
                siteName: siteName,
                dateSubmitted: dateSubmitted,
            },
            mySuccess,
            myError
        ),

    uploadUserData: (fileName, data, dateSubmitted, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "SCServiceV2.UploadUserData",
            {},
            {
                fileName: fileName,
                data: data,
                dateSubmitted: dateSubmitted,
            },
            mySuccess,
            myError
        ),

    upload: (file, mySuccess, myError) => makeUpload(API_URL_UP, CLIENT_ID, file, mySuccess, myError),

    getSiteInfoObj: (mySuccess, myError) =>
        makeRequest(API_URL, CLIENT_ID, "SCServiceV2.GetSiteInfoObj", {}, {}, mySuccess, myError),

    getSiteObj: (siteMstID, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "SCServiceV2.GetSiteObj",
            {},
            {
                siteMstID: siteMstID,
            },
            mySuccess,
            myError
        ),

    getAllowedCountryMstIDs: (mySuccess, myError) =>
        makeRequest(API_URL, CLIENT_ID, "SCServiceV2.GetAllowedCountryMstIDs", {}, {}, mySuccess, myError),

    getIndInfoObj: (mySuccess, myError) =>
        makeRequest(API_URL, CLIENT_ID, "SCServiceV2.GetIndInfoObj", {}, {}, mySuccess, myError),

    getSiteCharByTimeInfoObj: (mySuccess, myError) =>
        makeRequest(API_URL, CLIENT_ID, "SCServiceV2.GetSiteCharByTimeInfoObj", {}, {}, mySuccess, myError),

    getMostRecentYearRanges: (mySuccess, myError) =>
        makeRequest(API_URL, CLIENT_ID, "SCServiceV2.GetMostRecentYearRanges", {}, {}, mySuccess, myError),

    getMstIDs: (mySuccess, myError) =>
        makeRequest(API_URL, CLIENT_ID, "SCServiceV2.GetMstIDs", {}, {}, mySuccess, myError),

    getDataTemplate: (sitesIncludedBoolArr, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "SCServiceV2.GetDataTemplate",
            {},
            {
                sitesIncluded: sitesIncludedBoolArr,
            },
            mySuccess,
            myError
        ),
};

export const DMService = {
    ping: (mySuccess, myError) => makeRequest(API_URL, CLIENT_ID, "DMServiceV2.Ping", {}, {}, mySuccess, myError),

    sum: (a, b, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "DMServiceV2.Sum",
            {},
            {
                A: a,
                B: b,
            },
            mySuccess,
            myError
        ),

    getCountryList: (mySuccess, myError) =>
        makeRequest(API_URL, CLIENT_ID, "DMServiceV2.GetCountryList", {}, {}, mySuccess, myError),

    getProvinceList: (mstCountryID, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "DMServiceV2.GetProvinceList",
            {},
            {
                mstCountryID: mstCountryID,
            },
            mySuccess,
            myError
        ),

    getSNU_List: (mstCountryID, provinceID, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "DMServiceV2.GetSNUList",
            {},
            {
                mstCountryID: mstCountryID,
                provinceID: provinceID,
            },
            mySuccess,
            myError
        ),

    getBaseCoverage: (mstCountryID, provinceID, snuID, fiscalYearStart, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "DMServiceV2.GetBaseCoverage",
            {},
            {
                mstCountryID: mstCountryID,
                provinceID: provinceID,
                snuID: snuID,
                fiscalYearStart: fiscalYearStart,
                _3mc_On: _3mc_On,
            },
            mySuccess,
            myError
        ),

    getTargCoverage: (mstCountryID, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "DMServiceV2.GetTargCoverage",
            {},
            {
                mstCountryID: mstCountryID,
            },
            mySuccess,
            myError
        ),

    updateInputs: (
        mstCountryID,
        provinceID,
        snuID,
        targetYear,
        coveragesStr,
        calculateNonCrossCountry,
        calculateCrossCountry,
        mySuccess,
        myError
    ) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "DMServiceV2.UpdateInputs",
            {},
            {
                mstCountryID: mstCountryID,
                provinceID: provinceID,
                snuID: snuID,
                targetYear: targetYear,
                coveragesStr: coveragesStr,
                calculateNonCrossCountry: calculateNonCrossCountry,
                calculateCrossCountry: calculateCrossCountry,
            },
            mySuccess,
            myError
        ),

    calculate: (mySuccess, myError) =>
        makeRequest(API_URL, CLIENT_ID, "DMServiceV2.Calculate", {}, {}, mySuccess, myError),

    toJSON: (mySuccess, myError) => makeRequest(API_URL, CLIENT_ID, "DMServiceV2.ToJSON", {}, {}, mySuccess, myError),

    getResults: (
        mstCountryID,
        provinceID,
        snuID,
        TargetYear,
        coveragesStr,
        calculateNonCrossCountry,
        calculateCrossCountry,
        fiscalYearStart,
        mySuccess,
        myError
    ) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "DMServiceV2.GetResults",
            {},
            {
                mstCountryID: mstCountryID,
                provinceID: provinceID,
                snuID: snuID,
                targetYear: TargetYear,
                coveragesStr: coveragesStr,
                calculateNonCrossCountry: calculateNonCrossCountry,
                calculateCrossCountry: calculateCrossCountry,
                fiscalYearStart: fiscalYearStart,
                _3mc_On: _3mc_On,
            },
            mySuccess,
            myError
        ),

    getResult3: (
        mstCountryID,
        provinceID,
        snuID,
        targetYear,
        coveragesStr,
        calculateNonCrossCountry,
        calculateCrossCountry,
        finalYear,
        startAge,
        endAge,
        fiscalYearStart,
        mySuccess,
        myError
    ) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "DMServiceV2.GetResult3",
            {},
            {
                mstCountryID: mstCountryID,
                provinceID: provinceID,
                snuID: snuID,
                targetYear: targetYear,
                coveragesStr: coveragesStr,
                calculateNonCrossCountry: calculateNonCrossCountry,
                calculateCrossCountry: calculateCrossCountry,
                finalYear: finalYear,
                startAge: startAge,
                endAge: endAge,
                fiscalYearStart: fiscalYearStart,
            },
            mySuccess,
            myError
        ),

    getResult3Object: (
        mstCountryID,
        provinceID,
        snuID,
        targetYear,
        coveragesStr,
        calculateNonCrossCountry,
        calculateCrossCountry,
        finalYear,
        startAge,
        endAge,
        fiscalYearStart,
        mySuccess,
        myError
    ) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "DMServiceV2.GetResult3Object",
            {},
            {
                mstCountryID: mstCountryID,
                provinceID: provinceID,
                snuID: snuID,
                targetYear: targetYear,
                coveragesStr: coveragesStr,
                calculateNonCrossCountry: calculateNonCrossCountry,
                calculateCrossCountry: calculateCrossCountry,
                finalYear: finalYear,
                startAge: startAge,
                endAge: endAge,
                fiscalYearStart: fiscalYearStart,
            },
            mySuccess,
            myError
        ),

    generateLink: (
        fileName,
        mstCountryID,
        provinceID,
        snuID,
        targetYear,
        coveragesStr,
        calculateNonCrossCountry,
        calculateCrossCountry,
        fiscalYearStart,
        mySuccess,
        myError
    ) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "DMServiceV2.GenerateLink",
            {},
            {
                fileName: fileName,
                mstCountryID: mstCountryID,
                provinceID: provinceID,
                snuID: snuID,
                targetYear: targetYear,
                coveragesStr: coveragesStr,
                calculateNonCrossCountry: calculateNonCrossCountry,
                calculateCrossCountry: calculateCrossCountry,
                fiscalYearStart: fiscalYearStart,
                _3mc_On: _3mc_On,
                VersionName: GB_VersionName,
            },
            mySuccess,
            myError
        ),

    generateResultLink: (
        fileName,
        id,
        mstCountryID,
        provinceID,
        snuID,
        targetYear,
        coveragesStr,
        calculateNonCrossCountry,
        calculateCrossCountry,
        fiscalYearStart,
        mySuccess,
        myError
    ) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "DMServiceV2.GenerateResultLink",
            {},
            {
                fileName: fileName,
                id: id,
                mstCountryID: mstCountryID,
                provinceID: provinceID,
                snuID: snuID,
                targetYear: targetYear,
                coveragesStr: coveragesStr,
                calculateNonCrossCountry: calculateNonCrossCountry,
                calculateCrossCountry: calculateCrossCountry,
                fiscalYearStart: fiscalYearStart,
                _3mc_On: _3mc_On,
            },
            mySuccess,
            myError
        ),

    downloadCountryTemplate: (countryCode, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "DMServiceV2.DownloadCountryTemplate",
            {},
            {
                countryCode: countryCode,
            },
            mySuccess,
            myError
        ),

    getDMStatus: (mySuccess, myError) =>
        makeRequest(API_URL, CLIENT_ID, "DMServiceV2.GetDMStatus", {}, {}, mySuccess, myError),

    // uploadTemplate : (file, userName, mySuccess, myError) =>
    //     makeRequest(API_URL, CLIENT_ID, "DMService.UploadTemplate", {
    //         File: file,
    //         UserName : userName
    //     }, {}, mySuccess, myError),

    upload: (file, modID, mySuccess, myError) => makeUpload(API_URL_UP, CLIENT_ID, file, modID, mySuccess, myError),
};

export const RESTService = {
    getCountryList: (mode, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID_REST,
            "RESTServiceV2.GetCountryList",
            {},
            {
                mode: mode,
            },
            mySuccess,
            myError
        ),

    getCatInfoObj: (mySuccess, myError) =>
        makeRequest(API_URL, CLIENT_ID_REST, "RESTServiceV2.GetCatInfoObj", {}, {}, mySuccess, myError),

    getResultObject: (countryCode, levelMstID, indicatorMstID, year, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "RESTServiceV2.GetResultObject",
            {},
            {
                countryCode: countryCode,
                levelMstID: levelMstID,
                indicatorMstID: indicatorMstID,
                year: year,
            },
            mySuccess,
            myError
        ),

    getSiteCharacteristics: (countryCode, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "RESTServiceV2.GetSiteCharacteristics",
            {},
            {
                countryCode: countryCode,
            },
            mySuccess,
            myError
        ),

    /* DM */

    ping: (mySuccess, myError) => makeRequest(API_URL, CLIENT_ID, "RESTServiceV2.Ping", {}, {}, mySuccess, myError),

    sum: (a, b, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "RESTServiceV2.Sum",
            {},
            {
                A: a,
                B: b,
            },
            mySuccess,
            myError
        ),

    getCountryList: (mode, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "RESTServiceV2.GetCountryList",
            {},
            {
                mode: mode,
            },
            mySuccess,
            myError
        ),

    getProvinceList: (mstCountryID, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "RESTServiceV2.GetProvinceList",
            {},
            {
                mstCountryID: mstCountryID,
            },
            mySuccess,
            myError
        ),

    getSNU_List: (mstCountryID, provinceID, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "RESTServiceV2.GetSNUList",
            {},
            {
                mstCountryID: mstCountryID,
                provinceID: provinceID,
            },
            mySuccess,
            myError
        ),

    getBaseCoverage: (mstCountryID, provinceID, snuID, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "RESTServiceV2.GetBaseCoverage",
            {},
            {
                mstCountryID: mstCountryID,
                provinceID: provinceID,
                snuID: snuID,
            },
            mySuccess,
            myError
        ),

    getResultByID: (
        mstCountryID,
        provinceID,
        snuID,
        targetYear,
        coveragesStr,
        calculateNonCrossCountry,
        calculateCrossCountry,
        mstIndID,
        mySuccess,
        myError
    ) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "RESTServiceV2.GetBaseCoverage",
            {},
            {
                mstCountryID: mstCountryID,
                provinceID: provinceID,
                snuID: snuID,
                targetYear: targetYear,
                coveragesStr: coveragesStr,
                calculateNonCrossCountry: calculateNonCrossCountry,
                calculateCrossCountry: calculateCrossCountry,
                mstIndID: mstIndID,
            },
            mySuccess,
            myError
        ),

    getResultByFilters: (
        mstCountryID,
        provinceID,
        snuID,
        targetYear,
        coveragesStr,
        calculateNonCrossCountry,
        calculateCrossCountry,
        firstYear,
        finalYear,
        startAge,
        endAge,
        mstIndID,
        dataTypeFlag,
        mySuccess,
        myError
    ) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "RESTServiceV2.GetResultsByFilters",
            {},
            {
                mstCountryID: mstCountryID,
                provinceID: provinceID,
                snuID: snuID,
                targetYear: targetYear,
                coveragesStr: coveragesStr,
                calculateNonCrossCountry: calculateNonCrossCountry,
                calculateCrossCountry: calculateCrossCountry,
                firstYear: firstYear,
                finalYear: finalYear,
                startAge: startAge,
                endAge: endAge,
                mstIndID: mstIndID,
                dataTypeFlag: dataTypeFlag,
            },
            mySuccess,
            myError
        ),

    updateInputs: (
        mstCountryID,
        provinceID,
        snuID,
        targetYear,
        coveragesStr,
        calculateNonCrossCountry,
        calculateCrossCountry,
        mySuccess,
        myError
    ) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "RESTServiceV2.UpdateInputs",
            {},
            {
                mstCountryID: mstCountryID,
                provinceID: provinceID,
                snuID: snuID,
                targetYear: targetYear,
                coveragesStr: coveragesStr,
                calculateNonCrossCountry: calculateNonCrossCountry,
                calculateCrossCountry: calculateCrossCountry,
            },
            mySuccess,
            myError
        ),

    calculate: (mySuccess, myError) =>
        makeRequest(API_URL, CLIENT_ID, "RESTServiceV2.Calculate", {}, {}, mySuccess, myError),

    toJSON: (mySuccess, myError) => makeRequest(API_URL, CLIENT_ID, "RESTServiceV2.ToJSON", {}, {}, mySuccess, myError),

    getResults: (
        mstCountryID,
        provinceID,
        snuID,
        targetYear,
        coveragesStr,
        calculateNonCrossCountry,
        calculateCrossCountry,
        mySuccess,
        myError
    ) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "RESTServiceV2.GetResults",
            {},
            {
                mstCountryID: mstCountryID,
                provinceID: provinceID,
                snuID: snuID,
                targetYear: targetYear,
                coveragesStr: coveragesStr,
                calculateNonCrossCountry: calculateNonCrossCountry,
                calculateCrossCountry: calculateCrossCountry,
                _3mc_On: _3mc_On,
            },
            mySuccess,
            myError
        ),

    getCustomSnuData1: (
        mstCountryID,
        provinceID,
        snuID,
        targetYear,
        coveragesStr,
        calculateNonCrossCountry,
        calculateCrossCountry,
        mySuccess,
        myError
    ) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "RESTServiceV2.GetCustomSnuData1",
            {},
            {
                mstCountryID: mstCountryID,
                provinceID: provinceID,
                snuID: snuID,
                targetYear: targetYear,
                coveragesStr: coveragesStr,
                calculateNonCrossCountry: calculateNonCrossCountry,
                calculateCrossCountry: calculateCrossCountry,
            },
            mySuccess,
            myError
        ),

    getResult3: (
        mstCountryID,
        provinceID,
        snuID,
        targetYear,
        coveragesStr,
        calculateNonCrossCountry,
        calculateCrossCountry,
        finalYear,
        startAge,
        endAge,
        mySuccess,
        myError
    ) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "RESTServiceV2.GetResult3",
            {},
            {
                mstCountryID: mstCountryID,
                provinceID: provinceID,
                snuID: snuID,
                targetYear: targetYear,
                coveragesStr: coveragesStr,
                calculateNonCrossCountry: calculateNonCrossCountry,
                calculateCrossCountry: calculateCrossCountry,
                finalYear: finalYear,
                startAge: startAge,
                endAge: endAge,
            },
            mySuccess,
            myError
        ),

    generateLink: (
        fileName,
        mstCountryID,
        provinceID,
        snuID,
        targetYear,
        coveragesStr,
        calculateNonCrossCountry,
        calculateCrossCountry,
        mySuccess,
        myError
    ) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "RESTServiceV2.GenerateLink",
            {},
            {
                fileName: fileName,
                mstCountryID: mstCountryID,
                provinceID: provinceID,
                snuID: snuID,
                targetYear: targetYear,
                coveragesStr: coveragesStr,
                calculateNonCrossCountry: calculateNonCrossCountry,
                calculateCrossCountry: calculateCrossCountry,
                _3mc_On: _3mc_On,
            },
            mySuccess,
            myError
        ),

    generateResultLink: (
        fileName,
        id,
        mstCountryID,
        provinceID,
        snuID,
        targetYear,
        coveragesStr,
        calculateNonCrossCountry,
        calculateCrossCountry,
        mySuccess,
        myError
    ) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "RESTServiceV2.GenerateResultLink",
            {},
            {
                fileName: fileName,
                id: id,
                mstCountryID: mstCountryID,
                provinceID: provinceID,
                snuID: snuID,
                targetYear: targetYear,
                coveragesStr: coveragesStr,
                calculateNonCrossCountry: calculateNonCrossCountry,
                calculateCrossCountry: calculateCrossCountry,
                _3mc_On: _3mc_On,
            },
            mySuccess,
            myError
        ),

    downloadCountryTemplate: (countryCode, mySuccess, myError) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "RESTServiceV2.DownloadCountryTemplate",
            {},
            {
                countryCode: countryCode,
            },
            mySuccess,
            myError
        ),

    getDMStatus: (mySuccess, myError) =>
        makeRequest(API_URL, CLIENT_ID, "RESTServiceV2.GetDMStatus", {}, {}, mySuccess, myError),

    getResult3Object: (
        mstCountryID,
        provinceID,
        snuID,
        targetYear,
        coveragesStr,
        calculateNonCrossCountry,
        calculateCrossCountry,
        finalYear,
        startAge,
        endAge,
        mySuccess,
        myError
    ) =>
        makeRequest(
            API_URL,
            CLIENT_ID,
            "RESTServiceV2.GetResult3Object",
            {},
            {
                mstCountryID: mstCountryID,
                provinceID: provinceID,
                snuID: snuID,
                targetYear: targetYear,
                coveragesStr: coveragesStr,
                calculateNonCrossCountry: calculateNonCrossCountry,
                calculateCrossCountry: calculateCrossCountry,
                finalYear: finalYear,
                startAge: startAge,
                endAge: endAge,
            },
            mySuccess,
            myError
        ),

    getVersion: (successCallback, errorCallback) => {
        return makeRequest(
            API_URL,
            CLIENT_ID,
            "RESTServiceV2.Version",
            {}, // payload
            {}, // options
            successCallback, // Pass success callback
            errorCallback // Pass error callback
        );
    },
};

//======================================================================================================================
//
//                                             HELPER CALLS
//
//======================================================================================================================

export function uuidv4() {
    let crypto = window.crypto || window.msCrypto;

    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        // eslint-disable-next-line no-mixed-operators
        (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
    );
}
//======================================================================================================================
//
//                                               CLIENT_ID
//
//======================================================================================================================

export let CLIENT_ID = localStorage.getItem("SC_CLIENT_ID")
    ? localStorage.getItem("SC_CLIENT_ID")
    : "{" + uuidv4() + "}";

let CLIENT_ID_REST = "{" + uuidv4() + "}";

if (localStorage.getItem("SC_CLIENT_ID")) {
    localStorage.getItem("SC_CLIENT_ID");
} else {
    let ID = "{" + uuidv4() + "}";
    localStorage.setItem("SC_CLIENT_ID", ID);
    CLIENT_ID = ID;
}
